var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "desp"
  }, [_c('div', {
    staticClass: "desp-header"
  }, [_vm._v("Linked Orders:")]), _vm._l(_vm.detail.orderList, function (item) {
    return _c('div', {
      key: "orderList-".concat(item.id),
      staticClass: "desp-items-group"
    }, [_c('div', {
      staticClass: "desp-items-group-title"
    }, [_vm._v("Order Information")]), _c('div', {
      staticClass: "desp-items-wrapper"
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Applicant Name")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(_vm._s(item.applicantName))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Transaction No.")]), _c('div', {
      staticClass: "blue crp desp-item-content",
      on: {
        "click": function click($event) {
          return _vm.toLinkOrderDetail(item.id);
        }
      }
    }, [_vm._v(_vm._s(item.businessNo))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Order No.")]), _c('div', {
      staticClass: "blue crp desp-item-content",
      on: {
        "click": function click($event) {
          return _vm.invoiceLink(item.orderNo);
        }
      }
    }, [_vm._v(_vm._s(item.orderNo))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Oder Status")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(_vm._s(_vm.orderStatusFormat(item.status)))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Create Time")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(_vm._s(item.createTime))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Description")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(_vm._s(item.description))])])])], 1)], 1)]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }